/**
 * Standard Button Styles for Request Details View
 * 
 * All buttons in the request details view should use this consistent styling
 * to maintain a uniform appearance across the application.
 * 
 * Usage:
 * import { standardButtonStyle } from './buttonStyles';
 * 
 * <Button sx={standardButtonStyle}>Button Text</Button>
 */

export const standardButtonStyle = {
    padding: '5px 25px',
    fontSize: '0.7rem',
    textTransform: 'none',
    background: 'linear-gradient(180deg, #3b9edd 0%, #267db7 54%, #1e3a5f 125%)',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': {
        background: 'linear-gradient(180deg, #2a8acc 0%, #1e6aa6 54%, #162d4e 125%)',
    },
    '&:disabled': {
        background: '#cbd5e1',
        color: '#94a3b8',
    }
};

/**
 * Button variant for error/cancel actions
 */
export const cancelButtonStyle = {
    padding: '5px 25px',
    fontSize: '0.7rem',
    textTransform: 'none',
    background: 'linear-gradient(180deg, #ef4444 0%, #dc2626 54%, #991b1b 125%)',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': {
        background: 'linear-gradient(180deg, #dc2626 0%, #b91c1c 54%, #7f1d1d 125%)',
    }
};
